// extracted by mini-css-extract-plugin
export default {"wrapper":"MerchantApiTokensCard_wrapper__rupPj"};